module.exports = __webpack_public_path__ + "img/card2.94a5461d.png";